<script setup lang="ts">
import CurrentAlmIcon from "@/components/CurrentAlmIcon/CurrentAlmIcon.vue";
import { cardKey, cardMetaKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import AttributeChip from "@/components/chip/AttributeChip.vue";
import { injectStrict } from "@/utils/vue";

import StickyNoteRow from "../StickyNoteRow.vue";
import StickerChip from "./internal/StickerChip.vue";
import StickyNoteTypeText from "./internal/StickyNoteTypeText.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);
const cardMeta = injectStrict(cardMetaKey);
</script>

<template>
  <div class="sticky-note-header">
    <StickyNoteRow v-if="cardMeta.levelOfDetails > 1 || board.state.finishedTicks > 0" class="row">
      <StickyNoteTypeText v-show="cardMeta.levelOfDetails > 1" :text="card.type.name" />

      <div v-show="card.almId && cardMeta.levelOfDetails > 1" class="alm">
        <AttributeChip
          name="alm-chip"
          as="a"
          target="_blank"
          :href="card.almIssueUrl"
          :text="card.almId"
        >
          <template #icon>
            <CurrentAlmIcon />
          </template>
        </AttributeChip>
      </div>
      <StickerChip v-show="cardMeta.levelOfDetails >= 1" class="flag" data-ignore-click />
    </StickyNoteRow>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/z-index" as zIndex;
@use "@/styles/variables";

.sticky-note-header {
  padding: 8px 8px 0;
  height: 28px;
  width: variables.$sticky-size;

  .row {
    display: flex;
    justify-content: flex-end;
  }

  .alm {
    z-index: zIndex.$low;
    flex-shrink: 0;

    :deep(.text) {
      max-width: 140px;
    }

    :deep(a) {
      text-decoration: none;
    }
  }

  .flag {
    flex-shrink: 0;
  }
}
</style>
